<app-common-detail
    [data]="dto"
></app-common-detail>
